import { render, staticRenderFns } from "./PolicyPrivacyPage.vue?vue&type=template&id=34a87801&scoped=true"
var script = {}
import style0 from "./PolicyPrivacyPage.vue?vue&type=style&index=0&id=34a87801&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a87801",
  null
  
)

export default component.exports